var _rect, _g, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPhoneGreen = function SvgPhoneGreen(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18542_22377",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18542_22377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.625 18C14.8889 18 13.1736 17.6215 11.4792 16.8646C9.78472 16.1076 8.24306 15.0347 6.85417 13.6458C5.46528 12.2569 4.39236 10.7153 3.63542 9.02083C2.87847 7.32639 2.5 5.61111 2.5 3.875C2.5 3.625 2.58333 3.41667 2.75 3.25C2.91667 3.08333 3.125 3 3.375 3H6.75C6.94444 3 7.11806 3.06597 7.27083 3.19792C7.42361 3.32986 7.51389 3.48611 7.54167 3.66667L8.08333 6.58333C8.11111 6.80556 8.10417 6.99306 8.0625 7.14583C8.02083 7.29861 7.94444 7.43056 7.83333 7.54167L5.8125 9.58333C6.09028 10.0972 6.42014 10.5938 6.80208 11.0729C7.18403 11.5521 7.60417 12.0139 8.0625 12.4583C8.49306 12.8889 8.94444 13.2882 9.41667 13.6562C9.88889 14.0243 10.3889 14.3611 10.9167 14.6667L12.875 12.7083C13 12.5833 13.1632 12.4896 13.3646 12.4271C13.566 12.3646 13.7639 12.3472 13.9583 12.375L16.8333 12.9583C17.0278 13.0139 17.1875 13.1146 17.3125 13.2604C17.4375 13.4062 17.5 13.5694 17.5 13.75V17.125C17.5 17.375 17.4167 17.5833 17.25 17.75C17.0833 17.9167 16.875 18 16.625 18Z",
    fill: "#38A169"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6673 9.22027C13.6152 9.20291 13.5718 9.17253 13.5371 9.12912C13.5024 9.08572 13.485 9.03219 13.485 8.96853V7.02409H13.1378C12.9468 7.02409 12.7833 6.95609 12.6474 6.8201C12.5114 6.6841 12.4434 6.52062 12.4434 6.32964V3.55187C12.4434 3.36089 12.5114 3.19741 12.6474 3.06141C12.7833 2.92542 12.9468 2.85742 13.1378 2.85742H15.1691C15.3542 2.85742 15.5033 2.92976 15.6161 3.07444C15.729 3.21911 15.7622 3.37826 15.7159 3.55187L15.2211 5.28798H15.6118C15.8201 5.28798 15.9749 5.38057 16.0762 5.56576C16.1774 5.75094 16.1673 5.93034 16.0458 6.10395L13.9625 9.1161C13.9277 9.16819 13.8829 9.20291 13.8279 9.22027C13.7729 9.23763 13.7194 9.23763 13.6673 9.22027Z",
    fill: "#38A169"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPhoneGreen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Phone-green.f480b54e.svg";
export { ForwardRef as ReactComponent };